import {
 LinearProgressProps, Box, LinearProgress, Typography,
} from '@mui/material';
import React from 'react';
import { ProgressWithLabelWrap, ProgressWithLabelProgressWrap } from './styled';

type ProgressWithLabelProps = LinearProgressProps & { value: number };

export default function ProgressWithLabel({ value, ...props }: ProgressWithLabelProps) {
	return (
		<ProgressWithLabelWrap>
			<ProgressWithLabelProgressWrap>
				<LinearProgress
					variant="determinate"
					sx={{ borderRadius: '9px' }}
					value={value}
					{...props}
				/>
			</ProgressWithLabelProgressWrap>
			<Box>
				<Typography variant="body2">{`${Math.round(value)}%`}</Typography>
			</Box>
		</ProgressWithLabelWrap>
	);
}
